import styled, { css, keyframes } from 'styled-components';
import { color, transition } from '@kis-technologies/kis-ui';

interface SvgProps {
  size?: number;
  complete?: boolean;
}

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const dashRotate = keyframes`
  0% {
    stroke-dashoffset: 180;
    transform: rotate(0deg);
  }
  60% {
    stroke-dashoffset: 90;
    transform: rotate(180deg);
  }
  100% {
    stroke-dashoffset: 180;
    transform: rotate(360deg);
  }
`;

const dash = keyframes`
  from {
    stroke-dashoffset: 180;
  }
  to {
    stroke-dashoffset: 0;
  }
`;

const dashCheck = keyframes`
  from {
    stroke-dashoffset: -100;
  }
  to {
    stroke-dashoffset: 900;
  }
`;

const baseAttributes = css`
  stroke-miterlimit: 10;
  stroke-width: 4.65;
  stroke-linecap: round;
  stroke: ${color.GREEN};
  fill: none;
`;

const size = (props: SvgProps) =>
  props.size &&
  css`
    width: ${props.size}px;
    height: ${props.size}px;
  `;

const animateSvg = (props: SvgProps) =>
  !props.complete &&
  css`
    animation: 3000ms linear infinite ${rotate};
  `;

const animateCircle = (props: SvgProps) => {
  return props.complete
    ? css`
        animation: ${dash} 1500ms ${transition.CURVE};
      `
    : css`
        animation: ${dashRotate} 1500ms ${transition.CURVE} infinite both;
      `;
};

const animateCheck = (props: SvgProps) =>
  props.complete &&
  css`
    animation: ${dashCheck} 3000ms 750ms ${transition.CURVE} forwards;
  `;

export const Circle = styled.circle`
  ${baseAttributes};
  stroke-dasharray: 180;
  transform-origin: center;
`;

export const Check = styled.polyline`
  ${baseAttributes};
  stroke-dashoffset: -100;
  stroke-dasharray: 1000;
`;

export const SvgText = styled.text`
  opacity: 0;
  text-anchor: middle;
  fill: ${color.GREEN};
  font-size: 10px;
  font-weight: 600;
`;

export const Svg = styled.svg<SvgProps>`
  ${animateSvg};
  ${size};

  ${Circle} {
    ${animateCircle};
  }

  ${Check} {
    ${animateCheck};
  }
`;
